import React, { useContext, useEffect, useState, useRef } from "react";
import { NavLink as Link, useLocation } from "react-router-dom";

const Footer = () => {
  const [showTopUp, setShowTopUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const firstSectionHeight = document.getElementById("first-section")?.offsetHeight || 0;
      setShowTopUp(window.scrollY > firstSectionHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTopUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
  <footer className="leftrightSecSpace">
    <div className="footerIn">
      <div className="row">
        <div className="col-sm-3">
          <div className="fLogo">
            <img className="mb-2 logoSmall" src="./images/ufo.svg" alt="" />
            <p>UFO Token stands as a pivotal amplifier within The Grays ecosystem, strategically engineered to foster unity between the Richard Heart (RH) ecosystem and The Grays Currency.</p>
          </div>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4">
          <ul>
            <li><Link to='/ufo-pools'>Farming</Link></li>
            <li><Link to='/ufo-reward'>Rewards</Link></li>
            <li><Link to='/ufo-onboarding'>Onboarding</Link></li>
            <li><Link to='/ufo-statistics'>Statistics <span className="upper">New</span></Link></li>
          </ul>

        </div>
        <div className="col-sm-4">
          <ul>
            
            <li><Link target="_blank" rel="noopener noreferrer" to='https://www.dextools.io/app/en/pulse/pair-explorer/0xbea0e55b82eb975280041f3b49c4d0bd937b72d5?t=1762433857563'>Dextools</Link></li>
            <li><Link target="_blank" rel="noopener noreferrer" to='https://dexscreener.com/pulsechain/0xbea0e55b82eb975280041f3b49c4d0bd937b72d5'>DexScreener</Link></li>
            <li><Link target="_blank" rel="noopener noreferrer" to='https://www.coingecko.com/en/coins/ufo-token'>CoinGecko</Link></li>
          </ul>
        </div>
      </div>
      <div className="copy d-flex justify-content-between flex-wrap">
        <span className='mb-2'>UFO © {new Date().getFullYear()}. All rights reserved.</span>
        <span className="mb-2 social">
          <a href='https://youtube.com/@TheGraysCurrency' target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-youtube"></i></a>
          <a href='https://t.me/thegrayscurrency' target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-telegram"></i></a>
          <a href='https://x.com/PulseTGC' target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-x-twitter"></i></a>
        </span>
      </div>
    </div>
  </footer>
  {showTopUp && (
        <button className='topup UFOSEC'
          onClick={handleTopUp}
          
        >
          <i className="fa-solid fa-chevron-up"></i>
        </button>
      )}

    </>
  );
};
export default Footer;